import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';
import { Text, Title, Link as UILink } from '@paygreen/paygreen-ui';
import { ModalForm, Message } from '../../../components';
import ContributorsList from './ContributorsList';

const ContributionsExplanationModal = ({ t, isOpen }) => (
    <ModalForm
        modalTitle={t('contributions.globalView.explanationModal.modalTitle')}
        blockWidth="xl"
        paddingLateral="md"
        paddingBottom="md"
        hasCloseCross={true}
        isOpen={isOpen}
    >
        <Title htmlTag="h4" marginBottom="xs">
            {t('contributions.globalView.explanationModal.contribution.title')}
        </Title>

        <Text textSize="xs" colorWab="grey50" marginTop="xs">
            <Trans i18nKey="contributions.globalView.explanationModal.contribution.text">
                ...
                <Text textSize="xs" htmlTag="strong" colorWab="grey50">
                    {{
                        emissionReduction: t(
                            'contributions.globalView.explanationModal.contribution.emissionReduction',
                        ),
                    }}
                </Text>
                ...
            </Trans>
        </Text>

        <Title htmlTag="h4" marginTop="xs">
            {t('contributions.globalView.explanationModal.differences.title')}
        </Title>

        <Text textSize="xs" colorWab="grey50" marginTop="xs">
            <Trans i18nKey="contributions.globalView.explanationModal.differences.text">
                ...
                <Text textSize="xs" htmlTag="strong" colorWab="grey50">
                    {{
                        notCancelled: t(
                            'contributions.globalView.explanationModal.differences.notCancelled',
                        ),
                    }}
                </Text>
                ...
            </Trans>
        </Text>

        <Text textSize="xs" colorWab="grey50" marginTop="sm">
            <Trans i18nKey="contributions.globalView.explanationModal.differences.noNeutrality">
                ...
                <Text htmlTag="strong" textSize="xs" colorWab="grey50">
                    {{
                        planet: t(
                            'contributions.globalView.explanationModal.differences.planet',
                        ),
                    }}
                </Text>
                ...
            </Trans>
            {' '}
            {/* cannot apply Trans component on <link> and <a> */}
            <a
                href="https://www.ademe.fr/sites/default/files/assets/documents/avis-ademe-neutralite-carbone-2021.pdf"
                target="_blank"
                rel="noopener noreferrer"
            >
                <UILink
                    colorPallet="status"
                    colorStatus="success"
                    textSize="xs"
                >
                    {t(
                        'contributions.globalView.explanationModal.differences.ademeLink',
                    )}
                </UILink>
            </a>{' '}
            <Text textSize="xs" colorWab="grey50" htmlTag="span">
                {t('contributions.globalView.explanationModal.differences.end')}
            </Text>
        </Text>

        <Message type="success" paddingLateral="sm" marginTop="md">
            <Text textSize="xs" colorPallet="status" colorStatus="success">
                <Trans i18nKey="contributions.globalView.explanationModal.differences.neutralityMessage">
                    ...
                    <Text
                        textSize="xs"
                        colorPallet="status"
                        colorStatus="success"
                        htmlTag="strong"
                    >
                        {{
                            collectiveNeutrality: t(
                                'contributions.globalView.explanationModal.differences.collectiveNeutrality',
                            ),
                        }}
                    </Text>
                    ...
                </Trans>
            </Text>
        </Message>

        <Title htmlTag="h4" marginBottom="xs" marginTop="sm">
            {t(
                'contributions.globalView.explanationModal.whoContributes.title',
            )}
        </Title>

        <ContributorsList />

        <Title htmlTag="h4" marginTop="sm">
            {t(
                'contributions.globalView.explanationModal.contributeSoon.title',
            )}
        </Title>

        <Text textSize="xs" colorWab="grey50" marginTop="xs">
            <Trans i18nKey="contributions.globalView.explanationModal.contributeSoon.soonToPurchaseText">
                ...
                <Text textSize="xs" htmlTag="strong" colorWab="grey50">
                    {{
                        days: t(
                            'contributions.globalView.explanationModal.contributeSoon.days',
                        ),
                    }}
                </Text>
                ...
            </Trans>
        </Text>

        <Text textSize="xs" marginTop="xs" colorWab="grey50">
            {t('contributions.globalView.explanationModal.contributeSoon.end')}
        </Text>
    </ModalForm>
);

ContributionsExplanationModal.propTypes = {
    /**
     * @description isOpen is automatically received from ModalControl parent
     */
    isOpen: PropTypes.bool,
};

ContributionsExplanationModal.defaultProps = {
    isOpen: false,
};

export default withTranslation('common')(ContributionsExplanationModal);
